import React, { useState, useEffect } from "react";
import FilterCard from "../../components/filterCard";
import { LuCrown } from "react-icons/lu";
import { AiOutlineHeart } from "react-icons/ai";
import Select from "react-select";
import {
  BottleBabyIcon,
  BottleIcon,
  CameraDslrIcon,
  CameraIcon,
  CameraLensIcon,
  CameraMirorIcon,
  CloudyIcon,
  ColdBigIcon,
  ColdIcon,
  CompassIcon,
  EReaderIcon,
  EsProductsIcon,
  HotSaleIcon,
  LaptopIcon,
  LuggageIcon,
  OutdoorIcon,
  StackIcon,
  SuiteCaseIcon,
  TabletIcon,
  TravelIcon,
  UrbanIcon,
  WorkerIcon,
  WorkerWomenIcon,
  ReportIcon,
  CrownIcon,
  GoProIcon
} from "../../utils/icons";
import { ImPriceTag } from "react-icons/im";
import StyledInputRange from "../../components/styledInputRange";
import {
  useGetTagsQuery,
  useLazyGetPackingListSearhQuery,
} from "../../services/Api";
import Button from "../../components/button";
import { Country, State, City } from "country-state-city";
import { FiChevronDown } from "react-icons/fi";
import { TbWorld } from "react-icons/tb";
import { FaFlag } from "react-icons/fa";
import { REGIONS, REGIONSOPTIONS } from "../../utils/region";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { countryOptions } from "../adminPanel/pages/addPackingList/utils";
import { IoIosBody } from "react-icons/io";
import { FaBoxesPacking } from "react-icons/fa6";
import { TbTimeDuration10 } from "react-icons/tb";
import { LuActivity } from "react-icons/lu";
import { IoMdArrowForward } from "react-icons/io";

const PackingFilter = ({ isLoading, setShowSaved, setFilter, handleFetch, triggerSaved }) => {
  const [error, setError] = useState("");
  const auth = useSelector((data) => data?.auth);
  const navigate = useNavigate()
  const [state, setState] = useState({
    progress: null,
    isDestinationType: "Country",
    selectedRegion: "",
    countries: [],
    allCountries: [],
    states: [],
    cities: [],
    filters: {
      bodyType: "",
      packingStyle: "",
      region: "",
      country: "",
      state: "",
      city: "",
      climate: "",
      duration: null,
      activityScale: "",
      tech: "",
      toiletry: "",
      type: '',
      tags: "",
    },
    destinations: [],
  });

  const { data: dataTag, isLoading: tagLoading } = useGetTagsQuery();
  const getTags = dataTag?.data;

  const [getPackingListSearch, { data, isLoading: DataLoading, isError }] =
    useLazyGetPackingListSearhQuery();

  const handleStepClick = (step) => {
    setState((prev) => ({ ...prev, progress: step }));
  };
  const handleTagsChange = (selectedOptions) => {
    console.log("values here", selectedOptions)
    if (Array.isArray(selectedOptions) && selectedOptions.length <= 3) {
      setState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          tags: selectedOptions.map((opt) => opt.label),
        },
      }));
      setError(""); // Clear error when selection is valid
    } else {
      setError("You can select up to 3 tags only."); // Set error message
    }
  };
  const handleCountrChange = (selectedOptions) => {
    if (Array.isArray(selectedOptions)) {
      setState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          destinations: selectedOptions.map((opt) => opt.value),
        },
      }));
      setError(""); // Clear error when selection is valid
    }
  };
  const handleRegionChange = (selectedOptions) => {
    if (Array.isArray(selectedOptions)) {
      setState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          destinations: selectedOptions.map((opt) => opt.value),
        },
      }));
      setError(""); // Clear error when selection is valid
    }
  };


  const tagOptions = Array.isArray(getTags)
    ? getTags.map((item) => ({
      value: item._id,
      label: item.name,
    }))
    : [];

  useEffect(() => {
    if (state.selectedRegion) {
      const regionCountries =
        REGIONS.find((r) => r.name === state.selectedRegion)?.countries || [];
      const filteredCountries = Country.getAllCountries().filter((country) =>
        regionCountries.includes(country.isoCode)
      );
      setState((prev) => ({
        ...prev,
        countries: filteredCountries,
        states: [],
        cities: [],
        filters: {
          ...prev.filters,
          country: "",
          state: "",
          city: "",
          destinations: state.selectedRegion,
        },
        destinations: [...prev.destinations, { region: state.selectedRegion }],
      }));
    }
  }, [state.selectedRegion]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        country: '',
        region: '',
      },
    }));
  }, [state.isDestinationType]);

  useEffect(() => {
    if (state.filters.country) {
      const countryStates = State.getStatesOfCountry(state.filters.country);
      setState((prev) => ({
        ...prev,
        states: countryStates,
        cities: [],
        filters: { ...prev.filters, state: "", city: "" },
      }));
    }
  }, [state.filters.country]);
  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    if (state.filters.state) {
      const stateCities = City.getCitiesOfState(
        state.filters.country,
        state.filters.state
      );
      setState((prev) => ({
        ...prev,
        cities: stateCities,
        filters: { ...prev.filters, city: "" },
      }));
    }
  }, [state.filters.state]);

  const handleChange = (key, value) => {
    setState((prev) => ({
      ...prev,
      filters: { ...prev.filters, [key]: value },
    }));
  };

  const toggleArrayValue = (key, value) => {
    setState((prev) => {
      const current = Array.isArray(prev.filters[key]) ? prev.filters[key] : [];
      return {
        ...prev,
        filters: {
          ...prev.filters,
          [key]: current.includes(value)
            ? current.filter((item) => item !== value)
            : [...current, value],
        },
      };
    });
  };
  console.log("data in", state?.filters)

  const handleProClick = () => {
    navigate("/all-packing-list?type=PRO");
  };

  const handleButtonClick = () => {
    const filtersWithNames = {
      ...state.filters,
    };

    // Filter out keys with empty, null, or undefined values
    const cleanedFilters = Object.keys(filtersWithNames).reduce((acc, key) => {
      const value = filtersWithNames[key];
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    setFilter(cleanedFilters);

    // Generate URL with only valid params
    navigate(`/all-packing-list?${new URLSearchParams(cleanedFilters).toString()}`);
  };

  const savePackingListHandel = () => {
    if (auth?.isLoggedIn) {
      navigate('/user-saved-packing-list')
    } else {
      toast.success('Please Login to Show Saved Packing List');
      navigate('/login')
    }
  }
  const customStyles = {
    placeholder: (base) => ({
      ...base,
      color: '#25231B', // custom color
      fontFamily: '"Quicksand", sans-serif !important', // custom font family
      fontWeight: 700, // custom font weight (optional) : '14px', // optional
    }),

  };

  return (
    <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 max-w-[76rem] mx-auto mt-4 sm:mt-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        {/* Row 1: Body Type and Packing Style */}
        <div className="w-full">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/bodytypenew.png" alt="Body Type" className="w-4 h-4 sm:w-5 sm:h-5" />
            Body Type
          </label>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-3 sm:gap-5">
              {["FEMALE", "MALE"].map((type) => (
                <FilterCard
                  key={type}
                  title={type}
                  onClick={() => handleChange("bodyType", type)}
                  className={`${state.filters.bodyType === type
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm md:text-base"
                  Icon={type == "MALE" ? WorkerIcon : WorkerWomenIcon}
                  horizental={true}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/packingstylenew.png" alt="Packing Style" className="w-4 h-4 sm:w-5 sm:h-5" />
            Packing Style
          </label>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-2 sm:gap-5 flex-wrap">
              {["Minimal", "Lite", "Prepared", "Extra_prepared"].map((style, index) => (
                <FilterCard
                  key={style}
                  title={style == 'Extra_prepared' ? 'Extra Prepared' : style}
                  className={`${capitalizeWords(state.filters.packingStyle) == style
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm"
                  onClick={() => {
                    handleChange("packingStyle", style.toUpperCase());
                    handleStepClick(index);
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Row 2: Destination (Full Width) */}
        <div className="col-span-1 sm:col-span-2 mt-2">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/destinationnew.png" alt="Destination" className="w-4 h-4 sm:w-5 sm:h-5" />
            Destination
          </label>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-3 sm:gap-5 mb-2">
              <FilterCard
                title={"Country"}
                className={`${state.isDestinationType == "Country"
                  ? "bg-orange text-white"
                  : "bg-aths text-dark"
                  }`}
                Icon={FaFlag}
                titleClass="text-xs sm:text-sm"
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    isDestinationType: "Country",
                  }))
                }
                horizental={true}
              />
              <FilterCard
                title={"Multiple"}
                className={`${state.isDestinationType == "Multiple"
                  ? "bg-orange text-white"
                  : "bg-aths text-dark"
                  }`}
                Icon={TbWorld}
                titleClass="text-xs sm:text-sm"
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    isDestinationType: "Multiple",
                  }))
                }
                horizental={true}
              />
            </div>
            <div className="relative w-full mt-4 py-2 country_region_select ">
              {state.isDestinationType == "Multiple" && (
                <Select
                  isMulti
                  options={REGIONSOPTIONS}
                  value={
                    Array.isArray(state.filters.destinations)
                      ? state.filters.destinations.map((region) => ({
                        value: region,
                        label:
                          REGIONSOPTIONS.find((item) => item.value === region)?.label ||
                          region,
                      }))
                      : []
                  }
                  styles={customStyles}
                  onChange={handleRegionChange}
                  className="h-10 sm:h-12 rounded-lg w-full font-quicksand text-dark font-semibold text-sm sm:text-base"
                  placeholder="Where Are You Travelling To?"
                />
              )}

              {state.isDestinationType == "Country" && (
                <Select
                  isMulti
                  options={countryOptions}
                  value={
                    Array.isArray(state.filters.destinations)
                      ? state.filters.destinations.map((country) => ({
                        value: country,
                        label:
                          countryOptions.find((item) => item.value === country)?.label ||
                          country,
                      }))
                      : []
                  }
                  onChange={handleCountrChange}
                  styles={customStyles}
                  className="h-10 sm:h-12 rounded-lg w-full font-quicksand text-dark font-semibold text-sm sm:text-base"
                  placeholder="Where Are You Travelling To?"
                />
              )}
            </div>
          </div>
        </div>

        {/* Row 3: Climate and Duration */}
        <div className="w-full">
          <div className="flex justify-between items-center gap-3">
            <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
              <img src="/climatenew.png" alt="Climate" className="w-4 h-4 sm:w-5 sm:h-5" />
              Climate
            </label>
            <span className="text-xs text-black font-quicksand font-medium">
              select one or more
            </span>
          </div>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-3 sm:gap-5">
              {["COLD", "MILD", "HOT"].map((climate) => (
                <FilterCard
                  key={climate}
                  title={climate}
                  className={`${Array.isArray(state.filters.climate) &&
                    state.filters.climate.includes(climate)
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm"
                  onClick={() => toggleArrayValue("climate", climate)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="w-full">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/durationnew.png" alt="Duration" className="w-4 h-4 sm:w-5 sm:h-5" />
            Duration
          </label>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-2 sm:gap-5 flex-wrap">
              {[3, 7, 10, -1].map((duration) => (
                <FilterCard
                  key={duration}
                  title={duration === -1 ? "Long-Term" : `${duration} Days`}
                  className={`${state.filters.duration === duration
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm"
                  onClick={() => handleChange("duration", duration)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Row 4: Activity (Full Width) */}
        <div className="col-span-1 sm:col-span-2 mt-2">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/activitynew.png" alt="Activity" className="w-4 h-5 sm:w-5 sm:h-6" />
            Activity
          </label>
          <div className="bg-bgprimary p-3 rounded-2xl">
            <div className="w-full">
              <StyledInputRange
                state={state.filters.activityScale}
                setState={setState}
              />
              <div className="flex justify-between items-center mt-4">
                {["Urban", "Outdoor"].map((activity) => (
                  <button
                    key={activity}
                    className="px-3 sm:px-4 py-1.5 sm:py-2 border-2 border-white rounded-[8px] bg-black font-quicksand text-xs sm:text-sm font-bold text-bgprimary"
                  >
                    {activity}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Row 5: Tech (Full Width) */}
        <div className="col-span-1 sm:col-span-2">
          <div className="flex justify-between items-center gap-3">
            <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
              <img src="/technew.png" alt="Tech" className="w-5 h-5 sm:w-6 sm:h-6" />
              Tech
            </label>
            <span className="text-xs text-black font-quicksand font-medium">
              select one or more
            </span>
          </div>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-2 sm:gap-3 flex-wrap">
              {[
                "E-READER",
                "TABLET",
                "LAPTOP",
                "ACTION CAMERA",
                "MIRRORLESS",
                "DSLR",
                "LENSES",
              ].map((tech) => (
                <FilterCard
                  key={tech}
                  title={tech}
                  className={`${Array.isArray(state.filters.tech) &&
                    state.filters.tech.includes(tech)
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm"
                  onClick={() => toggleArrayValue("tech", tech)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Row 6: Toiletry and Type */}
        <div className="w-full mt-3">
          <div className="flex justify-between items-center gap-3">
            <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
              <img src="/toiletriesnew.png" alt="Toiletries" className="w-5 h-5 sm:w-6 sm:h-6" />
              Toiletries
            </label>
            <span className="text-xs text-black font-quicksand font-medium">
              select one or more
            </span>
          </div>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-2 sm:gap-3 flex-wrap">
              {["ESSENTIALS", "CARE", "Extra_Care"].map((toiletry) => (
                <FilterCard
                  key={toiletry}
                  title={toiletry == 'Extra_Care' ? 'Extra Care' : toiletry}
                  className={`${Array.isArray(state.filters.toiletry) &&
                    state.filters.toiletry.includes(toiletry)
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  Icon={
                    toiletry === "ESSENTIALS"
                      ? BottleIcon
                      : toiletry === "CARE"
                        ? EsProductsIcon
                        : BottleBabyIcon
                  }
                  titleClass="text-xs sm:text-sm"
                  onClick={() => toggleArrayValue("toiletry", toiletry)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="w-full mt-3">
          <div className="flex justify-between items-center gap-3">
            <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
              <img src="/typenew.png" alt="Type" className="w-4 h-4 sm:w-5 sm:h-5" />
              Type
            </label>
            <span className="text-xs text-black font-quicksand font-medium">
              select one or more
            </span>
          </div>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="flex items-center justify-start gap-2 sm:gap-3">
              {["REGULAR", "PRO"].map((type) => (
                <FilterCard
                  key={type}
                  title={type}
                  onClick={() => toggleArrayValue("type", type)}
                  className={`${Array.isArray(state.filters.type) && state.filters.type.includes(type)
                    ? "bg-orange text-white"
                    : "bg-aths text-dark"
                    }`}
                  titleClass="text-xs sm:text-sm"
                  Icon={type === "REGULAR" ? ReportIcon : CrownIcon}
                  horizental={true}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Row 7: Tags (Full Width) */}
        <div className="col-span-1 sm:col-span-2 mt-2">
          <label className="flex items-center gap-2 mb-2 text-sm sm:text-base font-roboto-mono italic text-dark font-bold">
            <img src="/tagsnew.png" alt="Tags" className="w-5 h-5 sm:w-6 sm:h-6" />
            Tags
          </label>
          <div className="bg-bgprimary px-3 py-4 sm:py-6 rounded-2xl">
            <div className="relative h-10 sm:h-12 rounded-lg country_region_select">
              <Select
                isMulti
                options={tagOptions}
                value={
                  Array.isArray(state.filters.tags)
                    ? state.filters.tags.map((tag) => ({
                      value: tag,
                      label:
                        tagOptions.find((item) => item.value === tag)?.label ||
                        tag,
                    }))
                    : []
                }
                styles={customStyles}
                onChange={handleTagsChange}
                className="h-10 sm:h-12 rounded-lg w-full font-quicksand text-dark font-semibold text-sm sm:text-base"
                placeholder="Select Tags"
              />
              {error && (
                <p className="text-errorcolor text-xs sm:text-sm text-center mt-1">{error}</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="flex justify-center mt-6 sm:mt-8">
        <Button
          label={<div className="flex flex-row items-center gap-1 text-center">
            <IoMdArrowForward size={18} className="text-dark" />
            <span className="text-xs sm:text-sm whitespace-nowrap">
              Show Packing List
            </span>
          </div>}
          onClick={handleButtonClick}
          className="flex items-center gap-3 border-2 border-dark px-4 sm:px-5 py-3 font-quicksand text-dark font-bold text-sm sm:text-base bg-white"
          loading={isLoading}
        />
      </div>
      <div className="mt-4 underline sm:mt-6 text-center font-quicksand font-medium text-dark text-sm sm:text-base">
        or
      </div>
      {/* PRO and Save Buttons */}
      <div className="flex flex-wrap justify-center gap-3 mt-3 sm:mt-4 mb-6">
        <Button
          onClick={handleProClick}
          label={
            <div className="flex flex-row gap-1 items-center text-center">
              <LuCrown size={25} className="text-dark" />
              <span className="text-xs sm:text-sm whitespace-nowrap">
                PRO Packing List
              </span>
            </div>
          }
          className="flex flex-col items-center border-2 border-dark px-3 sm:px-4 py-2 font-quicksand text-dark font-bold text-xs sm:text-sm bg-transparent w-auto"
        />
        <Button
          onClick={savePackingListHandel}
          label={
            <div className="flex flex-row gap-1 items-center text-center">
              <AiOutlineHeart size={25} className="text-dark" />
              <span className="text-xs sm:text-sm whitespace-nowrap">
                Saved List
              </span>
            </div>
          }
          className="flex flex-col items-center border-2 border-dark px-3 sm:px-4 py-2 font-quicksand text-dark font-bold text-xs sm:text-sm bg-transparent w-auto"
        />
      </div>
      {/* Loading, Error, or Data Display */}
      {DataLoading && <p className="text-center mt-4 text-sm sm:text-base">Loading Packing List...</p>}
      {isError && <p className="text-center mt-4 text-sm sm:text-base text-red-500">Error loading packing list</p>}
      {data && <></>}
    </div>
  );
};
export default PackingFilter;
